<div class="tab-content-wrapper mt-4">
  @if (loading) {
    <app-preloader></app-preloader>
  }
  @if (!loading) {
    <form class="form form_crm" [formGroup]="form" novalidate>
      <div class="row no-gutters gutters-4">
        <div class="col-6">
          <app-material-input formControlName="flat_voznagr_agenta" [placeholder]="'Вознаграждение агента (ДБ)'">
          Вознаграждение агента (ДБ)</app-material-input>
          <app-material-input formControlName="flat_voznagr_agenta_from_ddu" [placeholder]="'Вознаграждение агента (ДДУ)'">
            Вознаграждение агента (ДДУ)
          </app-material-input>
        </div>
        <div class="col-6">
          <app-material-input formControlName="flat_dolya_subagenta_db" [placeholder]="'Процент субагента (ДБ)'">
            Доля субагента (ДБ)
          </app-material-input>
          <app-material-input formControlName="flat_dolya_subagenta_agd" [placeholder]="'Процент субагента (АГД)'">
            Доля субагента (АГД)
          </app-material-input>
        </div>
        <div class="col-6">
          <app-material-input-datepicker formControlName="flat_srok_realisation" [placeholder]="'Срок реализации'">
            Срок реализации
          </app-material-input-datepicker>
        </div>
        <div class="col-6">
          <app-material-select2 formControlName="flat_status_id" [require]="true" [caption]="'Статус'">
            @for (status of flat_statuses; track status) {
              <option [value]="status.id">
                {{status.caption}}
              </option>
            }
          </app-material-select2>
        </div>
        <div class="col-12 mt-4">
          <button (click)="saveForm()"
            type="button" class="button button_main">
            Сохранить
          </button>
        </div>
      </div>
    </form>
  }
</div>
